export const RACE_ETHNICITY = {
    a: {
        en: 'Asian',
        es: 'Asiático'
    },
    b: {
        en: 'Black or African American',
        es: 'Negro o afroamericano'
    },
    h: {
        en: 'Hispanic or Latino',
        es: 'Hispano o latino'
    },
    i: {
        en: 'Indigenous, American Indian, or Alaskan Native',
        es: 'Indígena, indígena americano o nativo de Alaska'
    },
    haw: {
        en: 'Native Hawaiian or Other Pacific Islander',
        es: 'Nativo de Hawái u otra isla del Pacífico'
    },
    w: {
        en: 'White or Caucasian',
        es: 'Blanco o caucásico'
    },
    o: {
        en: 'Other',
        es: 'Otro'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    },
    idk: {
        en: 'Don’t Know',
        es: 'No sé'
    }
} as Record<string, { en: string; es: string }>;
